import React, {useEffect, useState} from 'react';
import {ArrowLeftOutlined,SaveOutlined,DeleteOutlined} from "@ant-design/icons";
import axios from "axios";
import {header} from "../../../../../../components/api/Header";
import {user_data} from "../../../../../../components/functions/usr";
import {NavLink} from "react-router-dom";
import swal from "sweetalert";
import {add_func} from "../../../../../../components/functions/Mathematik";
import { getEnv } from "../../../../../../lib/env";
function Add() {
    if(!user_data() || user_data().region_id != 16){
        window.location = '/limit/manbalar/iqtisodiyot'
    }
    const [hasData, setHasData] = useState(0)
    const [year, setYear] = useState('')
    const [lyear, setLyear] = useState(year)
    const [season, setSeason] = useState('veg')
    const [data, setData] = useState([])
    useEffect(()=>{
        const fetchData = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/region/limitmanbalar/iqtisodiyot?year="+year+"&season="+season, header())
                .catch(e=>{
                    console.log("Xato",e)
                    alert("Server bilan aloqa yo'q")
                })
            if(res){
                setData(res.data.data)
                setHasData(res.data.hasData)
            }
        }
        if(year){
            fetchData()
        }
    },[year,season])
    const setHandler = (v,i,d) => {
        let dat = [...data]
        if(dat[i]){
            dat[i][d] = v
            setChanged(true)
            dat[i]['jami_sanoat'] = add_func(add_func(add_func(dat[i]['energetika_qaytmas'],dat[i]['sanoatga']),add_func(dat[i]['kommunal'],dat[i]['baliq'])),dat[i]['boshqa'])
            dat[i]['jami'] = add_func(dat[i]['sugorishga'],dat[i]['jami_sanoat'])
        }

        setData(dat)
    }
    const [changed, setChanged] = useState(false)
    const doIt = async (action) => {
        const res = await axios.post(getEnv('REACT_APP_BASE_URL')+"/v1/region/limitmanbalar/"+action,{data,year,season}, header())
            .catch(e=>{
                console.log("Xato",e)
                alert("Server bilan aloqa yo'q!")
            })
        if(res){
            if(res.data.status == 200){
                swal("Muvaffaqiyalti", res.data.message, 'success')
                window.location = "/limit/manbalar/iqtisodiyot"
            }else{
                swal("Xato", res.data.message, 'error')
            }
        }
    }
    return (
        <>
            <div className="table-content-top">
                <div className="table-top-left d-flex align-items-center">
                    <NavLink to="/limit/manbalar/jami" className="btn btn-sm btn-outline-primary d-flex align-items-center">
                        <ArrowLeftOutlined />&nbsp;&nbsp;&nbsp;Qaytish
                    </NavLink>
                    &nbsp;&nbsp;&nbsp;
                    {
                        changed ? <button className="btn btn-sm btn-outline-primary d-flex align-items-center" onClick={()=>doIt('saveiqtisod')}>
                            Saqlash &nbsp;&nbsp;&nbsp;<SaveOutlined />
                        </button> :null
                    }
                    {
                        hasData ? <button className="btn btn-sm btn-outline-danger d-flex align-items-center" onClick={()=>doIt('deleteiqtisod')}>
                            O'chirish &nbsp;&nbsp;&nbsp;<DeleteOutlined />
                        </button> :null
                    }

                </div>
                <ul className="table-top-right">
                    <li className="d-flex align-items-center">
                        <input type="number" className="form-control form-control-sm" min={2015} max={parseInt(new Date().toISOString().slice(0,4))+2} value={lyear} onChange={e=>setLyear(e.target.value)}/>
                        &nbsp;&nbsp;&nbsp;
                        <button className="btn btn-sm btn-outline-primary" onClick={()=>setYear(lyear)}>Ok</button>
                    </li>
                    <li>
                        <select className="form-select form-select-sm" onChange={e=>setSeason(e.target.value)} value={season}>
                            <option value="veg">Sug'orish mavsumi</option>
                            <option value="noveg">Nosug'orish mavsumi</option>
                        </select>
                    </li>

                </ul>
            </div>
            <div className="table-responsive tableFixHead">
                <table className="table table-bordered table-style limit">
                    <thead>
                    <tr>
                        <th colSpan={11}>
                            O‘zbekiston Respublikasi bo‘yicha {year}-yilning {season == 'noveg' ? 'no' :null}vegetatsiya davrida suv manbalaridan jami iqtisodiyot tarmoqlariga ajratilgan suv olish limiti
                        </th>
                    </tr>
                    <tr>
                        <th scope="col" rowSpan={4}>№</th>
                        <th scope="col" rowSpan={4}>Tashkilot va hududlar nomi</th>
                        <th scope="col" rowSpan={4}>{year}- yilning {season == 'noveg' ? 'no' :null}sug‘orish davriga jami suv olish limiti* </th>
                        <th scope="col" colSpan={8}>sh u   j u m l a d a n</th>
                    </tr>
                    <tr>
                        <th scope="col" rowSpan={3}>Sug‘orishga</th>
                        <th scope="col" rowSpan={3}>Sanoat, kommunal xo‘jaligi va boshqa extiyojlar uchun</th>
                        <th scope="col" colSpan={6}>sh u   j u m l a d a n</th>
                    </tr>
                    <tr>
                        <th scope="col" colSpan={2}>Energetika</th>
                        <th scope="col" rowSpan={2}>Sanoatga</th>
                        <th scope="col" rowSpan={2}>Kommunal xo‘ja ligiga</th>
                        <th scope="col" rowSpan={2}>Baliqchilik xo‘jaligi</th>
                        <th scope="col" rowSpan={2}>Boshqalar</th>
                    </tr>
                    <tr>
                        <th scope="col">Jami olinadigan suv</th>
                        <th scope="col">Qaytmaydigan suv</th>
                    </tr>
                    </thead>
                    {
                        data.length > 0?
                            data.map((d,i) => {
                                return <tbody key={i}>
                                <tr>
                                    <th>{i+1}</th>
                                    <th style={{width:'250px',minWidth:'250px'}}>
                                        <p><b>{d.name}</b></p>
                                        <p><i>{d.title}</i></p>
                                    </th>
                                    <th scope="col" className="inserttr"><input type="number" className="insertable" readOnly value={d.jami?d.jami:''}/> </th>
                                    <th scope="col" className="inserttr"><input type="number" className="insertable" onChange={e=>setHandler(e.target.value,i,'sugorishga')} value={d.sugorishga?d.sugorishga:''}/> </th>
                                    <th scope="col" className="inserttr"><input type="number" className="insertable" readOnly value={d.jami_sanoat?d.jami_sanoat:''}/> </th>
                                    <th scope="col" className="inserttr"><input type="number" className="insertable" onChange={e=>setHandler(e.target.value,i,'energetika_jami')} value={d.energetika_jami?d.energetika_jami:''}/> </th>
                                    <th scope="col" className="inserttr"><input type="number" className="insertable" onChange={e=>setHandler(e.target.value,i,'energetika_qaytmas')} value={d.energetika_qaytmas?d.energetika_qaytmas:''}/> </th>
                                    <th scope="col" className="inserttr"><input type="number" className="insertable" onChange={e=>setHandler(e.target.value,i,'sanoatga')} value={d.sanoatga?d.sanoatga:''}/> </th>
                                    <th scope="col" className="inserttr"><input type="number" className="insertable" onChange={e=>setHandler(e.target.value,i,'kommunal')} value={d.kommunal?d.kommunal:''}/> </th>
                                    <th scope="col" className="inserttr"><input type="number" className="insertable" onChange={e=>setHandler(e.target.value,i,'baliq')} value={d.baliq?d.baliq:''}/> </th>
                                    <th scope="col" className="inserttr"><input type="number" className="insertable" onChange={e=>setHandler(e.target.value,i,'boshqa')} value={d.boshqa?d.boshqa:''}/> </th>
                                </tr>
                                </tbody>
                            })
                            :null
                    }
                </table>
            </div>
        </>
    );
}

export default Add;

